<template>
  <div style="padding-bottom: 66px;">
		<AppLoading v-if="carregando" />
    <template v-else-if="erro"> {{ erro }} </template>
    <template v-else-if="evento">
			<ComponentAuthGuard :requires="autorizacoesDoEvento">
				<v-btn
					fixed
					dark
					fab
					bottom
					right
					:style="{bottom: `${$vuetify.application.bottom + 10}px`}"
					color="primary"
					@click="() => $router.push({
						name: 'editar-evento',
						params: { id },
					})"
				>
					<v-icon>mdi-pencil</v-icon>
				</v-btn>
			</ComponentAuthGuard>
			<v-toolbar :color="obterCorDoEvento(agenda.tipoDaLabel)(evento)" dark>
				<v-container>
					<div class="px-3 d-flex align-center">
						<v-list-item-content>
							<v-list-item-title class="headline">{{evento.tipoDaSessao.nome}}</v-list-item-title>
							<v-list-item-subtitle>
								{{evento.entidade.nome}}
								<template v-if="evento.grauDaSessao">&mdash; {{ evento.grauDaSessao }} </template>
							</v-list-item-subtitle>
						</v-list-item-content>
						<IconeDoEvento
							:evento="evento" style="width: 42px; height: 42px;"
							class="mr-n2"
						/>
					</div>
				</v-container>
			</v-toolbar>
			<v-container class="px-0">
				<v-list-item v-if="evento.grauDaSessao">
					<v-list-item-icon class="mr-1">
					<v-icon :color="obterCorDoEvento(agenda.tipoDaLabel)(evento)"> mdi-square</v-icon>
					</v-list-item-icon>
					<v-list-item-content class="mr-1">
						<v-list-item-title v-text="evento.grauDaSessao" />
					</v-list-item-content>
				</v-list-item>
				<v-list-item>
					<v-list-item-icon class="mr-1">
						<v-icon> mdi-calendar</v-icon>
					</v-list-item-icon>
					<v-list-item-content class="mr-1">
						<v-list-item-title v-text="formatarData(evento.data)" />
					</v-list-item-content>
				</v-list-item>
				<v-card-text>
					<v-divider />
					<TextoComLinks :texto="evento.texto" />
				</v-card-text>

				<v-list dense v-if="evento.links.length">
					<v-list-item v-for="(link, index) in evento.links" :key="index">
						<v-list-item-content>
							<a :href="link.url" target="_blank" rel="noopener noreferrer">{{ link.texto }}</a>
						</v-list-item-content>
					</v-list-item>
				</v-list>

				<v-card-text>
					<template v-if="mostraPresenca">
						<AppLoading v-if="buscandoPresencas" />
						<BotoesDePresenca
							v-else-if="!passouDaData && inputPresenca"
							@input="trocarPresenca"
							:value="inputPresenca"
							:evento="evento"
						/>
					</template>
				</v-card-text>
				<v-card-title>
					<div> Presenças Confirmadas </div>
				</v-card-title>
				<v-card-text>
					<v-menu offset-y>
						<template #activator="{ on }">
							<v-btn color="primary" v-on="on" outlined>
								<v-icon left> mdi-printer </v-icon>
								Imprimir Lista
							</v-btn>
						</template>
						<v-list>
							<v-list-item
								v-for="(item, index) in opcoesDeOrdenacao"
								:key="index"
								@click="() => gerarRelatorio(item.valor)"
								color="primary"
							>
								<v-icon left v-text="item.icone"></v-icon>
								{{ item.descricao }}
							</v-list-item>
						</v-list>
					</v-menu>
				</v-card-text>
				<AppLoading v-if="buscandoPresencas" />
				<template v-else-if="erro"> {{ erroPresencas }} </template>
				<template v-else>
					<v-list-item v-if="!presencas.length">
						Nenhuma presença estimada...
					</v-list-item>
					<v-list-item
						v-for="presenca in presencasOrdenadas"
						:key="presenca._id"
						v-on="authModule.podeAbrirPerfil(presenca.irmao._id)
							? { click: () => $router.push({ name: 'detalhar-irmao', params: { id: presenca.irmao._id } }) }
							: {}"
						three-line
					>
						<v-list-item-avatar>
							<v-img
								v-if="'foto' in presenca.irmao && presenca.irmao.foto"
								:src="presenca.irmao.foto"
								style="object-fit: cover"
							>
								<template v-slot:placeholder>
									<v-progress-circular indeterminate color="grey"></v-progress-circular>
								</template>
							</v-img>
							<v-icon
								v-else
								v-text="'mdi-account'"
							/>
						</v-list-item-avatar>
						<v-list-item-content>
							<v-list-item-subtitle>
								{{ [
									'loja' in presenca.irmao && obterCargoDeAdminDaLoja(presenca.irmao),
									'cargoDeAdminDaPotencia' in presenca.irmao && presenca.irmao.cargoDeAdminDaPotencia && `${presenca.irmao.cargoDeAdminDaPotencia}`
								]
								.filter(cargo => !!cargo)
								.join(' / ') }}
							</v-list-item-subtitle>
							<v-list-item-title>
								{{ presenca.irmao.nomeCompleto }}
							</v-list-item-title>
							<v-list-item-subtitle>
								{{presenca.intencoes.includes('Não Vai')
									? 'Não vai'
									: `Vai a ${ presenca.intencoes.join(' e ')}`
								}}
							</v-list-item-subtitle>
						</v-list-item-content>
						<template v-if="!presenca.intencoes.includes('Não Vai')">
							<ComponentAuthGuard :requires="autorizacoesDeExclusao(presenca)">
								<v-list-item-action>
									<v-btn
										icon
										@click.stop="() => removerPresenca(presenca)"
									>
										<v-icon>mdi-delete</v-icon>
									</v-btn>
								</v-list-item-action>
							</ComponentAuthGuard>
						</template>
						<template v-if="presenca.certificado">
							<ComponentAuthGuard :requires="autorizacaoDeCertificado">
								<template #handler="{ hasAuthorization }">
									<v-list-item-action>
										<v-icon
											@click.stop="hasAuthorization && presenca.certificado.status === 'solicitado' ? selecionarCertificadoDaPresenca(presenca) : undefined"
											:color="obterCorDoStatusDoCertificado(presenca.certificado)"
										>
											mdi-certificate-outline
										</v-icon>
									</v-list-item-action>
								</template>
							</ComponentAuthGuard>
						</template>
					</v-list-item>
				</template>
			</v-container>
    </template>
	<DialogoDeAprovacaoDoCertificado
		v-if="certificado"
		v-model="mostraAprovacaoDoCertificado"
		:certificado="certificado"
		@change="aoAlterarCertificado"
	/>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import EventoService from '@/services/EventoService'
import { adminPotenciaGuard } from '@/shareds/sharedsPotencia'
import { adminLojaGuard } from '@/shareds/sharedsLoja'
import { IEvento } from '@/../common/types/Evento'
import ComponentAuthGuard from '@/components/ComponentAuthGuard.vue'
import { IPresenca, InputPresenca } from '@/../common/types/Presenca'
import PresencaService from '@/services/PresencaService'
import IconeDoEvento from '@/components/IconeDoEvento.vue'
import { formatarData } from '@/shareds/formatadores'
import BotoesDePresenca from '@/components/eventos/BotoesDePresenca.vue'
import { obterCargoDeAdminDaLoja } from './../../../common/shareds/sharedsIrmao'
import RelatorioService from '@/services/RelatorioService'
// @ts-ignore
import arraySort from 'array-sort'
import { alert, agenda, authModule, userModule } from '@/store'
import { criarPresenca, irmaoPodeVerPresenca, obterCorDoEvento } from '@/shareds/sharedsEvento'
import moment from 'moment'
import { getErrorMessage } from '@/helpers/error-helpers'
import { dataEHoraDoEvento } from '../../../common/shareds/sharedEvento'
import { obterCorDoStatusDoCertificado } from '@/shareds/sharedCertificado'
import { CertificadoDetalhado } from 'common/types/certificado/Certificado'
import DialogoDeAprovacaoDoCertificado from '@/components/certificado/DialogoDeAprovacaoDoCertificado.vue'
import { CARGOS_QUE_PODEM_GERAR_CERTIFICADO } from '@/../common/shareds/sharedCertificado'
import { éCargoDaLojaAtivo } from '@/../common/shareds/sharedLoja'
import { TipoDeOrdenacaoDeEvento } from 'common/types/Relatorio'
import TextoComLinks from '@/components/TextoComLinks.vue'

const props = defineProps({
	id: { type: String, required: true },
})

const carregando = ref(true)
const erro = ref<string | null>(null)
const evento = ref<IEvento | null>(null)
const mostraAprovacaoDoCertificado = ref(false)
const certificado = ref<CertificadoDetalhado | null>(null)

const buscandoPresencas = ref(true)
const erroPresencas = ref<string | null>(null)
const presencas = ref<IPresenca[]>([])
const inputPresenca = ref<InputPresenca | null>(null)

const opcoesDeOrdenacao = [
	{ descricao: 'Ordem Alfabética', valor: 'alfabetica', icone: 'mdi-sort-alphabetical-ascending' },
	{ descricao: 'Cargo/Relevância', valor: 'relevancia', icone: 'mdi-school' },
] satisfies { descricao: string, valor: TipoDeOrdenacaoDeEvento, icone: string }[]

const autorizacoesDoEvento = computed(() => {
	if (!evento.value) return []
	switch (evento.value.tipoDaSessao.abreviacao) {
		case 'FDJ':
		case 'DEMOL': {
			const { currentUser } = userModule
			return currentUser && currentUser.role !== 'Visitante' && currentUser.secretarioDeInformatica
		}
	}
	switch (evento.value.tipoDaSessao.tipoDaEntidade) {
		case 'somar': return ['admin']
		case 'potencia': return [adminPotenciaGuard(evento.value.entidade._id)]
		case 'loja': return [adminLojaGuard(evento.value.entidade._id)]
		default: return []
	}
})

function autorizacoesDeExclusao(presenca: IPresenca) {
	if (presenca.certificado) {
		return false
	}
	return autorizacoesDoEvento.value
}

const autorizacaoDeCertificado = computed(() => {
	const { currentUser } = userModule
	return currentUser &&
		currentUser.role !== 'Visitante' &&
		evento.value &&
		éCargoDaLojaAtivo(currentUser, CARGOS_QUE_PODEM_GERAR_CERTIFICADO, evento.value.entidade._id)
})

const presencasOrdenadas = computed(() => arraySort(presencas.value, [
	(presencaA: IPresenca, presencaB: IPresenca) => presencaB.intencoes.length - presencaA.intencoes.length,
	'irmao.nomeCompleto',
]))

const passouDaData = computed(() => {
	if (!evento.value) return true
	return moment().diff(dataEHoraDoEvento(evento.value)) >= 0
})

const mostraPresenca = computed(() => irmaoPodeVerPresenca(evento.value!, userModule.currentUser))

async function buscar() {
	try {
		carregando.value = true
		evento.value = await EventoService.get(props.id)
	} catch (error) {
		erro.value = getErrorMessage(error)
	} finally {
		carregando.value = false
	}
}

async function buscarPresencas() {
	const usuario = userModule.currentUser!
	try {
		buscandoPresencas.value = true
		presencas.value = await PresencaService.getByEvento(props.id)
		const presenca = presencas.value.find(presenca => presenca.irmao._id === usuario._id)

		inputPresenca.value = presenca
			? {
				...presenca,
				irmao: presenca.irmao._id,
			}
			: criarPresenca({
				evento: props.id,
				irmao: usuario._id,
			})
	} catch (error) {
		erroPresencas.value = getErrorMessage(error)
	} finally {
		buscandoPresencas.value = false
	}
}

buscar()
buscarPresencas()

function gerarRelatorio(ordenacao: TipoDeOrdenacaoDeEvento) {
	if (!evento.value) return
	const nomeRelatorio = `${evento.value.entidade.nome.replaceAll(' ','_')}_${evento.value.data}_${Date.now()}`
	const url = RelatorioService.getRelatorioDeEvento(nomeRelatorio, {
		evento: props.id,
		ordenacao,
	})
	window.open(url, '_blank')
}

function trocarPresenca(novaPresenca: InputPresenca) {
	inputPresenca.value = novaPresenca
	if (!userModule.currentUser) throw new Error('No current user')
	if (userModule.currentUser.role === 'Visitante') return

	const indiceDaPresenca = presencas.value.findIndex(presenca => presenca.irmao._id === novaPresenca.irmao)
	if (!novaPresenca.intencoes.length) {
		presencas.value.splice(indiceDaPresenca, 1)
		return
	}

	const presenca: IPresenca = {
		_id: novaPresenca._id!,
		intencoes: novaPresenca.intencoes,
		irmao: userModule.currentUser!,
		evento: novaPresenca.evento,
	}
	if (indiceDaPresenca === -1) {
		presencas.value.push(presenca)
	} else {
		presencas.value.splice(indiceDaPresenca, 1, presenca)
	}
}

async function removerPresenca(presenca: IPresenca) {
	try {
		if (!confirm(`Deseja remover ${presenca.irmao.nomeCompleto} desse evento?`)) return
		await PresencaService.remove(presenca._id)
		presencas.value = presencas.value
			.filter(({ _id }) => _id !== presenca._id)
		if (presenca.irmao._id === userModule.currentUser?._id) {
			inputPresenca.value = criarPresenca({
				evento: props.id,
				irmao: userModule.currentUser._id
			})
		}
	} catch (error) {
		alert.setError(error)
	}
}

function selecionarCertificadoDaPresenca(presenca: IPresenca) {
	if (!presenca.certificado) {
		alert.setError('Presenca não possui certificado')
		return
	}

	if (!evento.value) {
		alert.setError('Evento não carregado')
		return
	}

	certificado.value = {
		...presenca.certificado,
		irmao: presenca.irmao,
		evento: evento.value,
	}
	mostraAprovacaoDoCertificado.value = true
}

function aoAlterarCertificado(certificadoAlterado: CertificadoDetalhado) {
	presencas.value = presencas.value.map(presenca => {
		return presenca?.certificado?._id === certificadoAlterado._id
			? { ...presenca, certificado: certificadoAlterado }
			: presenca
	})
	mostraAprovacaoDoCertificado.value = false

	alert.setMessage({
		type: certificadoAlterado.status === 'aprovado' ? 'success' : 'info',
		text: `Certificado do Ir∴ ${certificadoAlterado.irmao.nomeCompleto} ${certificadoAlterado.status}`
	})
}
</script>
